"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRefDimensions = void 0;
const react_1 = require("react");
// This hook returns the height and width of an element.
// It uses a ResizeObserver to detect changes in the size of the element.
const useRefDimensions = (ref) => {
    const [dimensions, setDimensions] = (0, react_1.useState)({ width: 0, height: 0 });
    (0, react_1.useEffect)(() => {
        const r = ref;
        const observer = new ResizeObserver((entries) => {
            const { width, height } = entries[0].contentRect;
            setDimensions({ width: Math.round(width), height: Math.round(height) });
        });
        if (r === null || r === void 0 ? void 0 : r.current) {
            observer.observe(r.current);
        }
        return () => {
            if (r === null || r === void 0 ? void 0 : r.current)
                observer.unobserve(r.current);
        };
    }, [ref]);
    return dimensions;
};
exports.useRefDimensions = useRefDimensions;
//# sourceMappingURL=useRefDimensions.js.map